<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.sub_account") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(required autofocus type="text" size="sm" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getSubAccountList(true)")
              .form-group.col-9
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getSubAccountList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12
                b-button(type="button" variant="info" size="sm" @click="$router.push('/account/subAccountAdd')")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_sub_account") }}
              
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12 
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="11%" @click="sortOrder('login_id')")
                          span(:title="$t('ui.login_id')") {{ $t('ui.login_id') }}
                          .float-right
                            i(:class="changeSortKey('login_id')")
                        th.text-center(width="23%")
                          span(:title="$t('ui.authority_option')") {{ $t("ui.authority_option") }}
                        th(width="10%")
                          span(:title="$t('ui.last_login_ip')") {{ $t("ui.last_login_ip") }}
                        th.text-center(width="7%" @click="sortOrder('status')")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                          .float-right
                            i(:class="changeSortKey('status')")
                        th.text-center(width="8%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th.text-right(width="10%" @click="sortOrder('last_login_time')")
                          span(:title="$t('ui.last_login_time')") {{ $t("ui.last_login_time") }}
                          .float-right
                            i(:class="changeSortKey('last_login_time')")
                        th.text-right(width="12%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right
                            i(:class="changeSortKey('created_date')")
                    tbody.clusterize-content
                      tr(v-if="subAccountList.length == 0")
                        td(:colspan="8").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in subAccountList" :class="$helpers.rowClass(item)")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.login_id") {{ item.login_id }}
                        td.text-center.authority-col
                          template(v-if="item.authority_option")
                            span.badge.badge-info.align-middle.mr-1.p-1(v-for="obj in item.authority_option.split(',').sort()" style="width: auto;") {{ obj }}
                        td
                          span(:title="item.last_login_ip") {{ item.last_login_ip }}
                        td.text-center
                          span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                        td.actions.text-center
                          span
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEditAuthority(item)" :title="$t('ui.edit')")
                          span.ml-1
                            a.fa.fa-lock.btn.btn-ssm.btn-icon.btn-warning(href="javascript:void(0)" @click="onResetPasswordSub(item)" :title="$t('ui.reset_password')")
                          span.ml-1(v-if="item.status.toUpperCase() == 'BLOCK'")
                            a.fas.fa-lock-open.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onUnblockAccount(item)" :title="$t('ui.unblock')")
                          span.ml-1(v-if="item.status.toUpperCase() != 'BLOCK'")
                            a.fas.fa-ban.btn.btn-ssm.btn-icon.btn-info(href="javascript:void(0)" @click="onBlockAccount(item)" :title="$t('ui.block')")
                        td.text-right
                          span(:title="item.last_login_time ? $moment(item.last_login_time).format('YYYY-MM-DD, HH:mm:ss') : item.last_login_time") {{ item.last_login_time ? $moment(item.last_login_time).format('YYYY-MM-DD, HH:mm:ss') : item.last_login_time }}  
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}   
      
      editauthority(ref="editauthority" :item="selectedSubAcc" @clicked="afterEditAuthority" @failed="handleFailed")
      resetpasswordsub(ref="resetpasswordsub" :item="selectedSubAcc" @clicked="afterResetPasswordSub" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editauthority from "@/components/subAccount/editAuthority.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import resetpasswordsub from "@/components/subAccount/resetPasswordSub.vue";

export default {
  components: {
    editauthority,
    SubmitButton,
    DebounceInput,
    resetpasswordsub
  },
  data: () => ({
    loading: false,
    filterBy: "id",
    subAccountList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    selectedSubAcc: null,
    sortKey: "login_id",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    isMaster() {
      return [3].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isViewOnly() {
      return this.$helpers.showActionButton("e_operator");
    }
  },
  mounted: function() {
    this.getSubAccountList(true);
  },
  methods: {
    redirect() {
      this.getSubAccountList(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getSubAccountList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onEditAuthority(e) {
      this.selectedSubAcc = e;
      this.$refs.editauthority.$refs.editAuthority.show();
    },
    onResetPasswordSub(e) {
      this.selectedSubAcc = e;
      this.$refs.resetpasswordsub.$refs.resetPasswordSub.show();
    },
    afterEditAuthority: function() {
      this.getSubAccountList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_authority"), this.$t("message.success"), "success");
    },
    getSubAccountList: function(isSearch) {
      let url = config.accountSubListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: this.$store.getters.loginId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.search_account_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subAccountList = response.data.dt;
                this.totalRow = this.subAccountList.length > 0 ? this.subAccountList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSubAccountList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSubAccountList();
    },
    onBlockAccount: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.block_sub_account_confirm", { name: item.login_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBlockAccount(item);
          }
        });
    },
    confirmBlockAccount: function(item) {
      let url = config.accountSubBlockUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: item.login_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getSubAccountList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUnblockAccount: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.unblock_sub_account_confirm", { name: item.login_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblockAccount(item);
          }
        });
    },
    confirmUnblockAccount: function(item) {
      let url = config.accountSubUnblockUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: item.login_id,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getSubAccountList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addSubAccount: function() {
      this.search = "";
      this.currentPage = 1;
      this.getSubAccountList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_sub_account"), this.$t("message.success"), "success");
    },
    afterResetPasswordSub: function() {
      this.getSubAccountList();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>